import { Building2, CreditCard, Database, Mail, MoreHorizontal, Clock, Tag, Package, ShieldCheck, LifeBuoy, UserCog, Link2 } from "lucide-react";

export const ADMIN_SECTIONS = [["stores", "Stores", Building2], ["billing", "Billing", CreditCard], ["api", "API & Bulk", Database], ["emails", "Emails", Mail],
  ["trials", "Trials", Clock], ["promos", "Promos", Tag], ["master", "Master Data", Package], ["mappings", "Mappings", Link2], ["team", "Admins", ShieldCheck], ["support", "Support", LifeBuoy], ["profile", "Admin Profile", UserCog]];

export const MORE_TABS = [["trials", "Trials"], ["promos", "Promos"], ["master", "Master Data"], ["mappings", "Mappings"], ["team", "Admins"], ["support", "Support"], ["profile", "Profile"]];
const ITEMS = [["stores", "Stores", Building2], ["billing", "Billing", CreditCard], ["api", "API & Bulk", Database], ["emails", "Emails", Mail], ["more", "More", MoreHorizontal]];
export const navKey = (tab) => (MORE_TABS.some(([v]) => v === tab) ? "more" : tab);

export const AdminBottomNav = ({ tab, onSelect }) => (
  <nav data-testid="admin-bottom-nav" className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-[0_-4px_16px_rgba(107,33,168,0.08)] pb-[env(safe-area-inset-bottom)]">
    <div className="grid grid-cols-5">
      {ITEMS.map(([v, l, Icon]) => {
        const on = navKey(tab) === v;
        return (
          <button key={v} data-testid={`admin-nav-${v}`} onClick={() => onSelect(v === "more" ? (on ? tab : "trials") : v)}
            className={`h-16 flex flex-col items-center justify-center gap-1 text-[10px] font-bold transition-colors ${on ? "text-[#6B21A8]" : "text-slate-500"}`}>
            <Icon className="w-5 h-5" />{l}
          </button>
        );
      })}
    </div>
  </nav>
);

export const MoreSwitcher = ({ tab, onSelect }) => (
  <div data-testid="admin-more-switcher" className="lg:hidden grid grid-cols-3 sm:grid-cols-6 gap-1 p-1 bg-slate-100 rounded-xl">
    {MORE_TABS.map(([v, l]) => (
      <button key={v} data-testid={`admin-more-${v}`} onClick={() => onSelect(v)}
        className={`h-9 rounded-lg text-xs font-bold transition-colors ${tab === v ? "bg-[#6B21A8] text-white" : "text-slate-600"}`}>{l}</button>
    ))}
  </div>
);
